import React from 'react';

/** Replace the hrefs with your real policy and support links. */
const links = [{
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Terms & Conditions',
  href: '#terms'
}, {
  label: 'Contact / Support',
  href: '#contact'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-163" data-mp="3a4r5j4runwxs">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-164" data-mp="3f4nc9brxm2h1">
        <div data-id="element-165" data-mp="3k2fcqu6n6wwu">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-166" data-mp="3k1vtna59a2h8">
            Hair Extension Instructor Ready™
          </p>
          <p className="mt-1.5 font-body text-[13px]" data-id="element-167" data-mp="3t3n2gnv3epfb">Prof. Kyra · Digital educational resources</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-168" data-mp="1trkjdeqdrx26">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-169" data-mp="1yqdvb2q0rg08">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/55" data-id="element-170" data-mp="3nuughg29yg1x">
        © 2026 Hair Extension Instructor Ready™ by Prof. Kyra. Digital PDF teaching resources for hair extension
        instructors and beauty educators. Does not replace hands-on certification, manufacturer training, or
        applicable licensing requirements. Secure checkout — payment processed in your local currency.
      </p>
    </footer>;
}